import React from 'react';
export function ObjecionesSection() {
  return <section className="bg-[#FFFFFF] py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-opacity-50" data-id="element-89">
      <div className="max-w-6xl mx-auto flex flex-col items-center space-y-16" data-id="element-90">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F0F0F] text-center" data-id="element-91">
          Puede que estés pensando…
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full" data-id="element-92">
          {/* Card 1 */}
          <div className="bg-[#0F0F0F] p-8 rounded-3xl flex flex-col items-center text-center space-y-6 shadow-xl" data-id="element-93">
            <p className="text-2xl font-bold text-[#C9A96E]" data-id="element-94">
              "Yo ya trabajo mucho."
            </p>
            <p className="text-xl text-[#FFFFFF]" data-id="element-95">
              Entonces necesitas ver esto.
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-[#0F0F0F] p-8 rounded-3xl flex flex-col items-center text-center space-y-6 shadow-xl" data-id="element-96">
            <p className="text-2xl font-bold text-[#C9A96E]" data-id="element-97">
              "Esto será motivación."
            </p>
            <p className="text-xl text-[#FFFFFF]" data-id="element-98">
              No.
              <br data-id="element-99" />
              Es estrategia de agenda.
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-[#0F0F0F] p-8 rounded-3xl flex flex-col items-center text-center space-y-6 shadow-xl" data-id="element-100">
            <p className="text-2xl font-bold text-[#C9A96E]" data-id="element-101">
              "¿Qué puedo aprender en 90 minutos?"
            </p>
            <p className="text-xl text-[#FFFFFF]" data-id="element-102">
              Lo que muchos vendedores tardan años en descubrir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}